/** Backend messages for duplicate primary borrower (field error, not confirmable). */
const PRIMARY_DUPLICATE_PATTERNS = [
  "exists as a borrower",
  "this primary borrower already has an in-progress application",
];

/** Backend messages where the dealer can confirm and retry with ignore_duplicate. */
const COBORROWER_CONFIRM_PATTERNS = [
  "exists as a coborrower",
  "this co-borrower already has an in-progress application",
  "primary borrower already exists as a coborrower on another app",
];

export function isDuplicatePrimaryBorrowerError(message: string): boolean {
  const lower = message.toLowerCase();
  return PRIMARY_DUPLICATE_PATTERNS.some((pattern) => lower.includes(pattern));
}

export function isDuplicateCoborrowerConfirmableError(
  message: string,
): boolean {
  const lower = message.toLowerCase();
  return COBORROWER_CONFIRM_PATTERNS.some((pattern) => lower.includes(pattern));
}
